const accommodation = [
    {
        id : 'H001',
        destination_code : 'MDN',
        hotel_name : 'Hotel Deli River',
        hotel_code : 'HDR',
        room_type : 'Deluxe',
        extrabed : 'no',
        pax : 2,
        price : "Rp 800.000",

    },
    {
        id : 'H002',
        destination_code : 'MDN',
        hotel_name : 'Hotel Deli River',
        hotel_code : 'HDR',
        room_type : 'Deluxe',
        extrabed : 'yes',
        pax : 3,
        price : "Rp 800.000",

    },
    {
        id : 'H003',
        destination_code : 'MDN',
        hotel_name : 'Hotel Deli River',
        hotel_code : 'HDR',
        room_type : 'Family',
        extrabed : 'no',
        pax : 2,
        price : "Rp 2.000.000",

    },
]

export default accommodation